<template>
  <div class="search-enroll--content">
    <label>Клиент</label>
    <search-client :reset="resetSearchClient" v-model="clientSearch"></search-client>
    <div v-if="clientSearch" class="search-enroll--actions mrg-t-15">
      <div
          @click="searchEnroll('prev')"
          :class="{'btn-success': lastSearchMode == 'prev', 'btn-outline-info': lastSearchMode != 'prev'}"
          class="btn btn-sm"
      >
        Искать назад
      </div>
      <div
          @click="searchEnroll('today')"
          :class="{'btn-success': lastSearchMode == 'today', 'btn-outline-info': lastSearchMode != 'today'}"
          class="btn btn-sm"
      >
        Искать сегодня
      </div>
      <div
          @click="searchEnroll('next')"
          :class="{'btn-success': lastSearchMode == 'next', 'btn-outline-info': lastSearchMode != 'next'}"
          class="btn btn-sm"
      >
        Искать вперед
      </div>
    </div>
    <div v-if="data.length" class="align-right mrg-t-20">
      <div @click="data.reverse()" class="btn btn-sm btn-outline-info">
        <f-awesome icon="sort"></f-awesome>
      </div>
    </div>
    <div v-if="clientSearch && lastSearchMode" class="search-enroll--labels mrg-t-10">
      <h3>Текстовый список</h3>
      <text-labels :data="data"></text-labels>
      <h3 class="mrg-t-15">Ярлыки</h3>
      <only-labels
        @selectEnroll="selectEnroll"
        :data="data"
      ></only-labels>
    </div>

    <popup
        :closeButton="editEnrollPopup.closeButton"
        :show="editEnrollPopup.show"
        :size="editEnrollPopup.size"
        :backgroundColor="editEnrollPopup.backgroundColor"
        @closePopup="closeEditEnrollPopup"
    >
      <div slot="header">{{ editEnrollPopup.header }}</div>
      <div slot="body">
        <fast-new
            :loadEnrollId="selectedEnrollId"
            :default-date="fastNewDefaultDate"
            :want-time="wantTime"
            :show="editEnrollPopup.show"
            :mode="'edit'"
            @update="searchEnroll(lastSearchMode)"
            @updateLoadEnroll="updateLoadEnroll"
        ></fast-new>
      </div>
    </popup>

  </div>
</template>

<script>
import SearchClient from "@/components/panel/clients/SearchClient";
import OnlyLabels from "@/components/panel/journal/OnlyLabels";
import Popup from "@/components/Popup";
import FastNew from "@/components/panel/journal/fast_new/FastNew";
import Formatter from "@/components/libraries/Formatter";
import TextLabels from "@/components/panel/journal/TextLabels";
import enrollRepository from "../../../repositories/enroll";

const formatter = new Formatter();


export default {
  name: "SearchEnroll",
  components: {TextLabels, FastNew, Popup, OnlyLabels, SearchClient},
  data() {
    return {
      clientSearch: null,
      data: [],
      lastSearchMode: null,
      resetSearchClient: 0,
      editEnrollPopup: {
        show: false,
        size: "lg",
        header: "",
        backgroundColor: 'wgray'
      },
      selectedEnrollId: null,
      fastNewDefaultDate: "",
      wantTime: 0
    };
  },
  props: {
    reset: Boolean
  },
  watch: {
    clientSearch: function(){
      this.lastSearchMode = null;
    },
    reset: function(){
      this.lastSearchMode = null;
      this.clientSearch = null;
      this.resetSearchClient++;
    }
  },
  computed: {

  },
  methods: {
    selectEnroll(enroll){
      this.selectedEnrollId = +enroll.id;
      this.fastNewDefaultDate = formatter.phpDateToRus(enroll.date);
      this.wantTime = +enroll.time;
      this.editEnrollPopup.show = true;
    },
    closeEditEnrollPopup(){
      this.editEnrollPopup.show = false;
      this.selectedEnrollId = 0;
    },
    updateLoadEnroll(val) {
      this.selectedEnrollId = val;
    },
    searchEnroll(mode){
      this.$store.dispatch("startPreloader");
      this.lastSearchMode = mode;

      enrollRepository.searchEnroll({client_id: this.clientSearch.id, mode: mode}).then(resp => {
        this.data = resp.data;
        this.$store.dispatch("stopPreloader");
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
        this.$store.dispatch("stopPreloader");
      });
    }
  },
  created() {

  }
};
</script>

<style scoped lang="less">

</style>
